var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowLeftIcon } from '@phosphor-icons/react';
import { Alert, Anchor, Box, Button, Center, Container, Group, Paper, Text, TextInput, Title, } from '@mantine/core';
import classes from '../../../styles/ForgotPassword.module.css';
import { Link } from "react-router";
import { useState } from "react";
import { useForm } from "@mantine/form";
import { WarningIcon } from '@phosphor-icons/react';
import { Logo } from "../../partials/Logo";
export default function StepTwo(_a) {
    var _this = this;
    var uuid = _a.uuid, onComplete = _a.onComplete;
    var _b = useState(null), serverError = _b[0], setServerError = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var form = useForm({
        mode: 'controlled',
        initialValues: {
            code: '',
        },
    });
    var handleSubmit = function (values) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setServerError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetch('/api/password/reset/' + encodeURIComponent(uuid) + '/validate', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(values),
                        })];
                case 2:
                    response = _a.sent();
                    if (response.status !== 200) {
                        setServerError('Your reset code is not valid or has expired - please try again.');
                    }
                    else {
                        onComplete(values.code);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setServerError('Network error. Please check your connection.');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", { className: classes.wrapper, children: _jsxs(Container, { size: 460, my: 40, children: [_jsx(Logo, {}), _jsxs(Paper, { withBorder: true, shadow: "sm", p: 22, mt: 30, radius: "md", children: [_jsx(Title, { style: { fontFamily: "'Fredoka', var(--mantine-font-family), sans-serif" }, order: 2, ta: "center", size: "h3", fw: 700, children: "Forgot your password?" }), _jsx(Text, { c: "dimmed", size: "xs", ta: "center", mt: 4, mb: "lg", children: "Enter the reset code emailed to you" }), serverError &&
                            _jsx(Alert, { variant: "light", color: "red", title: "There was a problem", icon: _jsx(WarningIcon, {}), mb: "md", children: serverError }), _jsxs("form", { onSubmit: form.onSubmit(handleSubmit), children: [_jsx(TextInput, __assign({ label: "Reset code", required: true, radius: "md" }, form.getInputProps('code'))), _jsxs(Group, { justify: "space-between", mt: "lg", className: classes.controls, children: [_jsx(Anchor, { c: "dimmed", size: "sm", component: Link, to: "/login", className: classes.control, children: _jsxs(Center, { inline: true, children: [_jsx(ArrowLeftIcon, { size: 12 }), _jsx(Box, { ml: 5, children: "Back to the sign in page" })] }) }), _jsx(Button, { className: classes.control, type: "submit", children: "Verify" })] })] })] })] }) }));
}
